export default "__VITE_ASSET__BKpxyBPA__"